export class ScheduleDescriptionApi
{
    hour?: number;
    hours?: number[];
    scheduleValue: number;
    scheduleType: number;
    weekDays?: number[];
    monthDays?: number[];
    winterTime: boolean;
    intervalType: number;
    lastScheduleUTC: string;
    nextScheduleUTC: string;
    periodicity: number;
    predefInterval: number;
    tickIndex: number;
}
